import { Typography, TypographyOwnProps } from '@mui/material';
import React from 'react';

interface MainSubsectionTitleProps {
  children: React.ReactNode;
  sx?: TypographyOwnProps['sx'];
}

const MainSubsectionTitle: React.FC<MainSubsectionTitleProps> = ({ children, sx }) => {
  const typographySx = {
    color: '#01A32D',
    fontSize: '16px',
    fontWeight: '700',
    lineHeight: '24px',
    fontFamily: 'Roboto',
    ...sx,
  };

  return (
    <Typography variant="h4" sx={typographySx}>
      {children}
    </Typography>
  );
};

export default MainSubsectionTitle;
